import ResponseRenderer from "./ResponseRenderer";

export default function ChatMessage({ message }) {
    const isUser = message.from === "user";

    return (
        <div className={`flex gap-4 ${isUser ? "justify-end" : "justify-start"}`}>
            {!isUser && (
                <img
                    src="/icon_ai.png"
                    alt="bot"
                    className="hidden sm:block w-9 h-9 rounded-full object-cover"
                />
            )}

            <div
                className={`max-w-xl rounded-2xl px-5 py-3 text-sm leading-relaxed ${isUser
                    ? "bg-[#102D33] text-white"
                    : "bg-[#e0e0e0] text-black"
                    }`}
            >
                {isUser ? (
                    <pre className="whitespace-pre-wrap">{message.content}</pre>
                ) : (
                    <ResponseRenderer data={message.content} />
                )}
            </div>
        </div>
    );
}